<template>
  <div>
    <el-collapse-item title="报名表基本信息" name="interview_from_basic">
      <!--日本字段start-->
      <el-row>
        <el-col :span="2">年龄</el-col>
        <el-col :span="6">
          <el-input v-model="formData.age" class="width100" readonly />
        </el-col>
        <el-col :span="2">出生地</el-col>
        <el-col :span="6">
          <jm-areaselect v-model="bornplace" @change="setBornPlaceData" readonly />
        </el-col>
        <el-col :span="2">家庭电话</el-col>
        <el-col :span="6">
          <el-input v-model="formData.home_telephone" class="width150" />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">国籍</el-col>
        <el-col :span="6">
          <el-input v-model="formData.native" class="width100" />
        </el-col>
        <el-col :span="2">赴日次数</el-col>
        <el-col :span="14">
          <el-input v-model="formData.go_japan_num" class="width150" />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">婚姻状况</el-col>
        <el-col :span="6">
          <jm-dict-select
            class="width100"
            clearable
            type="dataset"
            v-model="formData.married"
            dict-type="student"
            name="married"
          />
        </el-col>
        <el-col :span="2">家庭住址</el-col>
        <el-col :span="14">
          <jm-areaselect v-model="nowplace" @change="setNowPlaceData" />
          <el-input v-model="formData.now_place" class="width300" />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">护照情况</el-col>
        <el-col :span="6">
          <jm-dict-select
            class="width100"
            clearable
            type="dataset"
            v-model="formData.has_passport"
            dict-type="student"
            name="hasPassport"
          />
        </el-col>
        <el-col :span="2">护照号</el-col>
        <el-col :span="14">
          <el-input v-model="formData.port_num" v-if="formData.has_passport === 1" class="width150" />
          <span v-else>暂无</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">是否日语专业</el-col>
        <el-col :span="6">
          <jm-dict-select
            class="width100"
            clearable
            type="dataset"
            v-model="formData.japanese_major"
            dict-type="student"
            name="japaneseMajor"
          />
        </el-col>
        <el-col :span="2">是否艺术生</el-col>
        <el-col :span="14">
          <jm-dict-select
            class="width100"
            clearable
            type="dataset"
            v-model="formData.art_exam"
            dict-type="student"
            name="artExam"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">最终学历</el-col>
        <el-col :span="6">
          <jm-dict-select
            class="width300"
            clearable
            dict="online.interview_education_2020"
            v-model="formData.final_edu"
            @change="() => formData.final_subject = ''"
          />
          <el-input
            class="width150"
            placeholder="学历名称"
            v-if="formData.final_edu === 2060"
            v-model="formData.final_school_other"
          />
        </el-col>
        <el-col :span="2">最终学历专业</el-col>
        <el-col :span="14">
          <el-input
            class="width150"
            v-if="formData.final_edu !== 2054"
            v-model="formData.final_subject"
          />
          <jm-dict-select
            v-else
            class="width150"
            clearable
            type="dataset"
            v-model="formData.final_subject"
            dict-type="student"
            name="examSubject"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">高考</el-col>
        <el-col :span="6">
          <jm-dict-select dict="dataset.student.examStatus" class="width100" v-model="hasGaoKao" />
        </el-col>
        <template v-if="hasGaoKao">
          <el-col :span="2">文理</el-col>
          <el-col :span="6">
            <jm-dict-select
              clearable
              class="width100"
              dict="dataset.student.examSubject"
              v-model="formData.gaokao"
            />
          </el-col>
          <el-col :span="2">分数</el-col>
          <el-col :span="6">
            <el-input v-model="formData.gaokao_score" class="width150" />
          </el-col>
        </template>
        <template v-else>
          <el-col :span="16"></el-col>
        </template>
      </el-row>
      <el-row>
        <el-col :span="2">会考</el-col>
        <el-col :span="6">
          <jm-dict-select
            dict="dataset.student.examStatus"
            class="width100"
            v-model="hasGeneralExam"
          />
        </el-col>
        <template v-if="hasGeneralExam">
          <el-col :span="2">文理</el-col>
          <el-col :span="6">
            <jm-dict-select
              clearable
              class="width100"
              dict="dataset.student.examSubject"
              v-model="formData.general_exam"
            />
          </el-col>
          <el-col :span="2">分数/等级</el-col>
          <el-col :span="6">
            <el-input v-model="formData.general_exam_score" class="width150" />
          </el-col>
        </template>
        <template v-else>
          <el-col :span="16"></el-col>
        </template>
      </el-row>

      <el-row>
        <el-col :span="2">艺考</el-col>
        <el-col :span="6">
          <jm-dict-select
            dict="dataset.student.examStatus"
            class="width100"
            v-model="hasArtExam"
          />
        </el-col>
        <template v-if="hasArtExam">
          <el-col :span="2">分数</el-col>
          <el-col :span="14">
            <el-input v-model="formData.art_exam_score" class="width150" />
          </el-col>
        </template>
        <template v-else>
          <el-col :span="16"></el-col>
        </template>
      </el-row>
      <el-row class="row-gray" v-if="formData.education_experience">
        <el-col :span="2">教育经历</el-col>
        <el-col :span="5">学校名称</el-col>
        <el-col :span="8">学校类型</el-col>
        <el-col :span="4">入学时间</el-col>
        <el-col :span="5">毕业时间</el-col>
      </el-row>
      <el-row v-for="(item, index) in formData.education_experience" :key="'jpedu-'+index">
        <el-col :span="2"></el-col>
        <el-col :span="5">
          <el-input v-model="item.sh_name" class="width200" />
        </el-col>
        <el-col :span="8">
          <jm-dict-select
            class="width150"
            clearable
            type="dataset"
            v-model="item.sh_type"
            dict-type="interviewForm"
            value-type="string"
            :name="['eduType', 'jpOtherEduType']"
          />
          <el-input
            style="margin-left:10px;"
            v-if="item.sh_type === '其他'"
            class="width150"
            v-model="item.education_other"
            placeholder='学校类型'
          />
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="item.start_time"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择日期"
            class="width150"
          ></el-date-picker>
        </el-col>
        <el-col :span="5">
          <el-date-picker
            v-model="item.end_time"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择日期"
            class="width150"
          ></el-date-picker>
        </el-col>
      </el-row>
      <el-row class="row-gray" v-if="formData.japanese_experience">
        <el-col :span="2">日语学习经历</el-col>
        <el-col :span="5">学校名称</el-col>
        <el-col :span="5">入学时间</el-col>
        <el-col :span="4">毕业时间</el-col>
        <el-col :span="8"></el-col>
      </el-row>
      <el-row v-for="(item, index) in formData.japanese_experience" :key="'jplearn-'+index">
        <el-col :span="2"></el-col>
        <el-col :span="5">
          <el-input v-model="item.name" class="width150" />
        </el-col>
        <el-col :span="5">
          <el-date-picker
            class="width150"
            v-model="item.starttime"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择日期"
          ></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="item.endtime"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择日期"
            class="width150"
          ></el-date-picker>
        </el-col>
        <el-col :span="8"></el-col>
      </el-row>
      <el-row class="row-gray" v-if="formData.japanese_exam">
        <el-col :span="2">日语考试</el-col>
        <el-col :span="5">考试名称</el-col>
        <el-col :span="3">考试种类</el-col>
        <el-col :span="5">考试等级</el-col>
        <el-col :span="3">参加状态</el-col>
        <el-col :span="3">考试时间</el-col>
        <el-col :span="3">分数</el-col>
      </el-row>
      <el-row v-for="(item, index) in formData.japanese_exam" :key="'jpexam-'+index">
        <el-col :span="2"></el-col>
        <el-col :span="5">
          <el-input v-if="item.name === ''" v-model="item.othername" class="width150" />
          <el-input v-else v-model="item.name" class="width150" />
        </el-col>
        <el-col :span="3">
          <jm-dict-select
            class="width100"
            clearable
            type="dataset"
            v-model="item.etype"
            value-type="string"
            dict-type="interviewForm"
            name="jpExamType"
          />
        </el-col>
        <el-col :span="5">
          <el-input v-model="item.otherlevel" v-if="item.etype === 'other'" />
          <jm-dict-select
            v-if="item.etype !== 'other'"
            class="width150"
            clearable
            type="online"
            v-model="item.exam_level"
            :dict-type="getJpExamLevelDictName(item.etype)"
          />
        </el-col>
        <el-col :span="3">
          <jm-dict-select
            class="width150"
            clearable
            type="dataset"
            v-model="item.exam_status"
            dict-type="student"
            name="generalStatus"
          />
        </el-col>
        <el-col :span="3">
          <el-date-picker
            v-model="item.time"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择日期"
            class="width150"
          ></el-date-picker>
        </el-col>
        <el-col :span="3">
          <el-input v-model="item.score" />
        </el-col>
      </el-row>
      <el-row class="row-gray" v-if="formData.work_experience">
        <el-col :span="2">职历</el-col>
        <el-col :span="5">公司名称</el-col>
        <el-col :span="4">在职状态</el-col>
        <el-col :span="5">入职时间</el-col>
        <el-col :span="5">离职时间</el-col>
        <el-col :span="3"></el-col>
      </el-row>
      <el-row v-for="(item, index) in formData.work_experience" :key="'jpwork-'+index">
        <el-col :span="2"></el-col>
        <el-col :span="5">
          <el-input v-model="item.name" class="width150" />
        </el-col>
        <el-col :span="4">
          <jm-dict-select
            class="width150"
            clearable
            type="dataset"
            v-model="item.company_status"
            dict-type="interviewForm"
            name="jobStatus"
          />
        </el-col>
        <el-col :span="5">
          <el-date-picker
            v-model="item.starttime"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择日期"
            class="width150"
          ></el-date-picker>
        </el-col>
        <el-col :span="5" v-if="parseInt(item.company_status) === 0">
          <el-date-picker
            v-model="item.endtime"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择日期"
            class="width150"
          ></el-date-picker>
        </el-col>
        <el-col :span="3" v-if="parseInt(item.company_status) === 0"></el-col>
        <el-col :span="8" v-if="parseInt(item.company_status) === 1"></el-col>
      </el-row>
      <el-row class="row-gray" v-if="formData.japan_experience">
        <el-col :span="2">日本签证申请历史</el-col>
        <el-col :span="5">签证类型</el-col>
        <el-col :span="4">赴日时间</el-col>
        <el-col :span="4">归国时间</el-col>
        <el-col :span="3">目的</el-col>
        <el-col :span="3">是否拒签</el-col>
        <el-col :span="3">拒签理由</el-col>
      </el-row>
      <el-row v-for="(item, index) in formData.japan_experience" :key="'apply-history-'+index">
        <el-col :span="2"></el-col>
        <el-col :span="5">
          <jm-dict-select
            class="width150"
            clearable
            type="dataset"
            v-model="item.visatype"
            value-type="string"
            dict-type="interviewForm"
            name="jpVisaType"
          />
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="item.starttime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            class="width150"
          ></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="item.endtime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            class="width150"
          ></el-date-picker>
        </el-col>
        <el-col :span="3">
          <el-input v-model="item.ends" class="width150" />
        </el-col>
        <el-col :span="3">
          <jm-dict-select
            class="width150"
            clearable
            type="dataset"
            v-model="item.deny"
            dict-type="student"
            name="isDeny"
          />
        </el-col>
        <el-col :span="3">
          <el-input v-model="item.denytext" class="width150" />
        </el-col>
      </el-row>
      <!--日本字段end-->
    </el-collapse-item>
    <el-collapse-item title="报名表亲朋情况" name="interview_from_relation">
      <el-row class="row-gray" v-if="formData.family_member">
        <el-col :span="2">家族成员情况</el-col>
        <el-col :span="2">关系</el-col>
        <el-col :span="2">姓名</el-col>
        <el-col :span="2">年龄</el-col>
        <el-col :span="2">职业</el-col>
        <el-col :span="3">就职公司/学校</el-col>
        <el-col :span="11">联系电话</el-col>
      </el-row>
      <el-row v-for="(item, index) in formData.family_member" :key="'jpfamily-'+index">
        <el-col :span="2"></el-col>
        <el-col :span="2">
          <jm-dict-select
            class="width100"
            clearable
            type="dataset"
            value-type="string"
            v-model="item.relation"
            dict-type="interviewForm"
            name="relations"
          />
        </el-col>
        <el-col :span="2">
          <el-input v-model="item.name" class="width100" />
        </el-col>
        <el-col :span="2">
          <el-input v-model="item.age" class="width100" />
        </el-col>
        <el-col :span="2">
          <el-input v-model="item.job" class="width100" />
        </el-col>
        <el-col :span="3">
          <el-input v-model="item.company" class="width150" />
        </el-col>
        <el-col :span="11">
          <el-input v-model="item.phone" class="width150" />
        </el-col>
      </el-row>
      <el-row class="row-gray" v-if="formData.japan_relatives">
        <el-col :span="2">在日朋友情况</el-col>
        <el-col :span="2">关系</el-col>
        <el-col :span="2">姓名</el-col>
        <el-col :span="2">年龄</el-col>
        <el-col :span="2">职业</el-col>
        <el-col :span="3">就职公司/学校</el-col>
        <el-col :span="1">国籍地域</el-col>
        <el-col :span="2">联系电话</el-col>
        <el-col :span="5">签证类型</el-col>
        <el-col :span="1">是否同住</el-col>
        <el-col :span="2">现住址</el-col>
      </el-row>
      <el-row v-for="(item, index) in formData.japan_relatives" :key="'jpfriend-'+index">
        <el-col :span="2"></el-col>
        <el-col :span="2">
          <jm-dict-select
            class="width100"
            clearable
            type="dataset"
            value-type="string"
            v-model="item.relation"
            dict-type="interviewForm"
            name="relations"
          />
        </el-col>
        <el-col :span="2">
          <el-input v-model="item.name" class="width100" />
        </el-col>
        <el-col :span="2">
          <el-input v-model="item.age" class="width100" />
        </el-col>
        <el-col :span="2">
          <el-input v-model="item.job" class="width100" />
        </el-col>
        <el-col :span="3">
          <el-input v-model="item.company" class="width150" />
        </el-col>
        <el-col :span="1">
          <el-input v-model="item.native" class="width100" />
        </el-col>
        <el-col :span="2">
          <el-input v-model="item.phone" class="width150" />
        </el-col>
        <el-col :span="5">
          <jm-dict-select
            class="jm-input110 width150"
            clearable
            type="dataset"
            v-model="item.visatype"
            dict-type="interviewForm"
            value-type="string"
            name="jpVisaType"
          />
          <el-input v-model="item.othertype" style="margin-left:10px;" class="width150" v-if="item.visatype === '其他'" placeholder="请填写签证类型" />
        </el-col>
        <el-col :span="1">
          <jm-dict-select
            class="jm-input110 width60"
            clearable
            type="dataset"
            v-model="item.islive"
            dict-type="student"
            name="isLive"
          />
        </el-col>
        <el-col :span="2">
          <el-input v-model="item.address" />
        </el-col>
      </el-row>
      <el-row class="row-gray" v-if="formData.funding_payer">
        <el-col :span="2">经费支付人情况</el-col>
        <el-col :span="4">关系</el-col>
        <el-col :span="2">姓名</el-col>
        <el-col :span="2">年龄</el-col>
        <el-col :span="2">职业</el-col>
        <el-col :span="3">就职公司/学校</el-col>
        <el-col :span="2">联系电话</el-col>
        <el-col :span="7">现住址</el-col>
      </el-row>
      <el-row v-for="(item, index) in formData.funding_payer" :key="'jppay-'+index">
        <el-col :span="2"></el-col>
        <el-col :span="4">
          <jm-dict-select
            class="width100"
            clearable
            type="dataset"
            value-type="string"
            v-model="item.relation"
            dict-type="interviewForm"
            name="relations"
          />
          <el-input v-model="item.othername" style="margin-left:10px;" class="width150" v-if="item.relation === '其他'" placeholder="请填写与本人关系" />
        </el-col>
        <el-col :span="2">
          <el-input v-model="item.name" class="width100" />
        </el-col>
        <el-col :span="2">
          <el-input v-model="item.age" class="width100" />
        </el-col>
        <el-col :span="2">
          <el-input v-model="item.job" class="width100" />
        </el-col>
        <el-col :span="3">
          <el-input v-model="item.company" class="width150" />
        </el-col>
        <el-col :span="2">
          <el-input v-model="item.phone" class="width150" />
        </el-col>
        <el-col :span="7">
          <el-input v-model="item.address" class="width200" />
        </el-col>
      </el-row>
    </el-collapse-item>
  </div>
</template>
<script>
import interviewMixin from './interviewFormMixin';

export default {
  name: 'InterviewFormJp',
  mixins: [interviewMixin],
  methods: {
    getJpExamLevelDictName(type) {
      if (type === 'jlpt') {
        return 'interview_jlpt';
      }
      if (type === 'jtest') {
        return 'interview_jtest';
      }
      if (type === 'nat') {
        return 'interview_jlpt';
      }
    }
  }
};
</script>
